import { originOf } from "@/utils/apiOrigin";
import { apiBaseForCell } from "@/utils/apiRegionAllowlist";

const CONSENT_PATH = "/oauth/consent";
const LOCAL_PARSE_ORIGIN = "https://oauth-return.invalid";

function targetFromFullPath(fullPath) {
  if (typeof fullPath !== "string" || !fullPath.startsWith("/") || fullPath.startsWith("//")) return null;
  try {
    const parsed = new URL(fullPath, LOCAL_PARSE_ORIGIN);
    if (parsed.origin !== LOCAL_PARSE_ORIGIN || parsed.pathname !== CONSENT_PATH) return null;
    const request = parsed.searchParams.get("request");
    const cell = parsed.searchParams.get("cell");
    if (!request || !cell) return null;
    return {
      fullPath: `${parsed.pathname}${parsed.search}${parsed.hash}`,
      request,
      cell,
    };
  } catch (e) {
    return null;
  }
}

export function oauthConsentTarget(route) {
  if (!route) return null;
  if (route.path === CONSENT_PATH) {
    return targetFromFullPath(route.fullPath || `${route.path}?${new URLSearchParams(route.query || {})}`);
  }
  if (route.path === "/signin") return targetFromFullPath(route.query && route.query.from);
  return null;
}

export function oauthApiBaseForRoute(route, defaultBase, env = process.env) {
  const target = oauthConsentTarget(route);
  return target ? apiBaseForCell(target.cell, defaultBase, env) : null;
}

export function oauthSessionMatchesApi(savedApiUrl, targetApiUrl) {
  const savedOrigin = originOf(savedApiUrl);
  const targetOrigin = originOf(targetApiUrl);
  return !!savedOrigin && !!targetOrigin && savedOrigin === targetOrigin;
}
